import { FC } from 'react';
import classNames from 'classnames';

import styles from './ArticleBullets.module.scss';

import { AltSummBullet } from 'contexts/summarian/summarian.utils';

export const ALLOWED_BRANDS_FOR_BULLETS = ['barrons'];

type CardBulletsContainerProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const CardBulletsContainer: FC<CardBulletsContainerProps> = ({ className, ...props }) => (
  <div {...props} className={classNames(styles.bulletsContainer, className)} />
);

type CardBulletItemProps = React.DetailedHTMLProps<React.LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>;

export const CardBulletItem: FC<CardBulletItemProps> = ({ className, ...props }) => (
  <li {...props}>
    <span className={classNames(styles.bulletsItem, className)}>{props.children}</span>
  </li>
);

export const BulletList: FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement>> = ({
  className,
  ...props
}) => <ul {...props} className={classNames(styles.bulletsList, className)} />;

type CardBulletsProps = {
  bullets: AltSummBullet[];
};

const CardBullets: FC<CardBulletsProps> = ({ bullets }) => {
  if (bullets.length === 0) {
    return null;
  }

  return (
    <CardBulletsContainer>
      <BulletList>
        {bullets.map(({ text }, index) => (
          <CardBulletItem key={`bullet-item-${index}`}>{text}</CardBulletItem>
        ))}
      </BulletList>
    </CardBulletsContainer>
  );
};

CardBullets.displayName = 'CardBullets';

export default CardBullets;
